import React, { useContext } from "react";
import { LanguageContext, text } from "../../../container/language";
import moment from "moment";

import "./style.scss";
import { usePageContext } from "../../../utils/PageContext";

const ArticleTitle = ({ data = {}, date, children }) => {
  const { lang } = usePageContext();
  const { title, subtitle } = data;

  return (
    <section class="bg-soft-primary">
      <div class="container pt-10 pb-19 pt-md-14 pb-md-20 text-center">
        <div class="row">
          <div class="col-md-10 col-xl-8 mx-auto">
            <div class="post-header">
              {/* <div class="post-category text-line">
             <a href="#" class="hover" rel="category">
                Teamwork
              </a> 
            </div> */}
              <>
                {date && (
                  <time datetime="" className="content-header__date">
                    <font>
                      <font>{moment(date).format("DD/MM/YY")}</font>
                    </font>
                  </time>
                )}

                <h1 class="display-1 mb-4">{text(title, lang) || children}</h1>
                {subtitle ? (
                  <p class="lead px-lg-5 px-xxl-8">
                    {text(title, lang) || children}
                  </p>
                ) : null}
              </>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ArticleTitle;
